const storagePrefix = 'pbf_'

const storage = {
  getToken: () => {
    return JSON.parse(
      window.localStorage.getItem(`${storagePrefix}token`) as string
    )
  },
  getUserId: () => {
    return window.localStorage.getItem(`${storagePrefix}userid`)
  },
  getBearerToken: () => {
    return `Bearer ${window.localStorage.getItem(`${storagePrefix}token`)}`
  },
  setToken: (token: string) => {
    window.localStorage.setItem(`${storagePrefix}token`, token)
  },
  setUserId: (token: string) => {
    window.localStorage.setItem(`${storagePrefix}userid`, token)
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`)
  },
}

export default storage
